exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transitionsList .transitions[data-v-5d13effe]{display:flex;flex-direction:column;width:100%}.transitionsList .showMoreWrapper[data-v-5d13effe]{text-align:center;margin-top:10px}.transitionsList .showMore[data-v-5d13effe]{cursor:pointer}.transitionsList .showMore[data-v-5d13effe]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d13effe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TransitionsList.vue
// module id = 109
// module chunks = 0